import { useContext } from 'react';
import { MeContext } from '../providers/Me';
import type { BillingFeatureId as GraphQLBillingFeatureId } from '../../__generated__/graphql';
import type { BillingFeatureId } from '@natomalabs/common/billing';

export default function useIsBillingFeatureEnabled(): (
  feature: GraphQLBillingFeatureId | BillingFeatureId | string
) => boolean {
  const { currentOrg } = useContext(MeContext);
  return (feature: GraphQLBillingFeatureId | BillingFeatureId | string) =>
    !!currentOrg?.enabledFeatures?.includes(feature as GraphQLBillingFeatureId);
}
